export const REFERRAL_FAQS_CONSTANTS = {
  TITLE: "Frequently Asked Questions",
  ITEMS: [
    {
      ID: 1,
      QUESTION: "What does my friend get?",
      ANSWER:
        "A 7-day free trial of the Premium plan once they've paid, upto 20% off their first Exly subscription, and free onboarding support.",
    },
    {
      ID: 2,
      QUESTION: "Can I refer someone who already has an Exly account?",
      ANSWER:
        "No, the referral discount and commission only apply to new Exly signups.",
    },
    {
      ID: 3,
      QUESTION: "Is there a limit to how much I can earn?",
      ANSWER:
        "No. You earn a flat 25% commission on every successful referral, with no cap.",
    },
    {
      ID: 4,
      QUESTION: "How do I track my referrals?",
      ANSWER:
        "All your referrals and their status show up in the Your referrals section above, updated in real time.",
    },
    {
      ID: 5,
      QUESTION: "What counts as a successful referral?",
      ANSWER:
        'A referral counts once your friend subscribes and their payment clears — only "Subscribed" status counts toward your earnings.',
    },
    {
      ID: 6,
      QUESTION: "When do I get paid?",
      ANSWER:
        "Your commission lands in your wallet as soon as their payment clears.",
    },
  ],
};
